import { useState } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { PhoneIcon, EnvelopeIcon, MapPinIcon } from "@heroicons/react/24/solid";
import useIsMobile from "../hooks/useIsMobile";
import { anatomyConstants } from "../constants/anatomyConstants";

const ContactPage = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("Customer Support");
  const [message, setMessage] = useState("");
  const isMobile = useIsMobile();

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({ firstName, lastName, email, phone, subject, message });
  };

  if (isMobile) {
    return (
      <div className="flex flex-col min-h-screen">
        <Navbar />

        <main className="flex-1 px-4 py-6">
          <div
            className="max-w-2xl mx-auto bg-white rounded-[10px] shadow"
            style={{
              "--main-color": anatomyConstants.mainColor,
              "--main-color-bold": anatomyConstants.mainColorBold,
            }}
          >
            <div className="bg-[var(--main-color)] text-white rounded-t-[10px] p-6 md:p-8 relative overflow-hidden">
              <h2
                className="mb-2"
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 800,
                  fontSize: 28,
                  letterSpacing: 1,
                }}
              >
                Contact Us
              </h2>
              <p
                className="mb-6"
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 300,
                  fontSize: 16,
                  letterSpacing: 1,
                }}
              >
                Any question or remarks?
                <br />
                Just write us a message!
              </p>

              <ul className="space-y-4">
                <li className="flex items-center">
                  <PhoneIcon className="w-5 h-5 text-white mr-3" />
                  <span className="text-sm md:text-base">
                    +90 538 275 09 63
                  </span>
                </li>
                <li className="flex items-center">
                  <EnvelopeIcon className="w-5 h-5 text-white mr-3" />
                  <span className="text-sm md:text-base">
                    info@wellztech.com
                  </span>
                </li>
                <li className="flex items-start">
                  <MapPinIcon className="w-5 h-5 text-white mt-1 mr-3" />
                  <span className="text-sm md:text-base whitespace-pre-line">
                    ODTÜ Teknokent, Silikon Blok{"\n"}Ankara, Türkiye
                  </span>
                </li>
              </ul>

              <div
                className="absolute -bottom-10 -right-10"
                style={{
                  width: 120,
                  height: 120,
                  backgroundColor: "var(--main-color-bold)",
                  borderRadius: "50%",
                  opacity: 0.5,
                  pointerEvents: "none",
                }}
              />
            </div>

            <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-8">
              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  First Name *
                </label>
                <input
                  type="text"
                  value={firstName}
                  required
                  onChange={(e) => setFirstName(e.target.value)}
                  className="w-full border-b-2 border-gray-300 focus:border-[var(--main-color)] outline-none pb-1"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Last Name *
                </label>
                <input
                  type="text"
                  value={lastName}
                  required
                  onChange={(e) => setLastName(e.target.value)}
                  className="w-full border-b-2 border-gray-300 focus:border-[var(--main-color)] outline-none pb-1"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border-b-2 border-gray-300 focus:border-[var(--main-color)] outline-none pb-1"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Phone Number
                </label>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full border-b-2 border-gray-300 focus:border-[var(--main-color)] outline-none pb-1"
                />
              </div>

              <div>
                <p className="block text-sm text-gray-600 mb-2">
                  Select Subject
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3">
                  {["Customer Support", "Sales", "Feedback"].map((opt) => (
                    <label
                      key={opt}
                      className="flex items-center text-gray-700"
                    >
                      <input
                        type="radio"
                        name="subject"
                        value={opt}
                        checked={subject === opt}
                        onChange={() => setSubject(opt)}
                        className="form-radio"
                        style={{ accentColor: "var(--main-color)" }}
                      />
                      <span className="ml-2">{opt}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Message
                </label>
                <textarea
                  rows="4"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="w-full border-b-2 border-gray-300 focus:border-[var(--main-color)] outline-none pb-2 resize-none"
                  placeholder="Write your message..."
                />
              </div>

              <div>
                <button
                  type="submit"
                  style={{
                    width: "100%", background: "linear-gradient(160deg, #35b5aa 0%, #249990 100%)",
                    color: "#fff", border: "none", borderRadius: "8px", padding: "12px",
                    fontWeight: 600, fontSize: "15px", cursor: "pointer",
                    boxShadow: "0 4px 14px rgba(48,164,151,0.35)", transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = "linear-gradient(160deg, #249990 0%, #1a7068 100%)"}
                  onMouseLeave={(e) => e.currentTarget.style.background = "linear-gradient(160deg, #35b5aa 0%, #249990 100%)"}
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </main>

        <Footer />
      </div>
    );
  }

  return (
    <div
      className="flex flex-col h-screen"
      style={{ backgroundColor: "#0B0E13" }}
    >
      <Navbar />
      <div className="flex flex-row flex-1 gap-6 p-8 pt-20">
        <div
          className="w-2/5 text-white p-20 m-2 relative rounded-[10px] overflow-hidden"
          style={{
            "--main-color": anatomyConstants.mainColor,
            "--main-color-bold": anatomyConstants.mainColorBold,
            backgroundColor: "var(--main-color)",
          }}
        >
          <h2
            className="mb-2"
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 800,
              fontSize: "28px",
              letterSpacing: "1px",
            }}
          >
            Contact Us
          </h2>
          <p
            className="mb-12"
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 300,
              fontSize: "18px",
              letterSpacing: "1px",
            }}
          >
            Any question or remarks?
            <br />
            Just write us a message!
          </p>
          <div style={{ height: 120 }} />
          <ul className="space-y-10">
            <li className="flex items-center">
              <PhoneIcon className="w-5 h-5 text-white mr-3" />
              <span
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: "16px",
                  letterSpacing: "1px",
                }}
              >
                +90 538 275 09 63
              </span>
            </li>
            <li className="flex items-center">
              <EnvelopeIcon className="w-5 h-5 text-white mr-3" />
              <span
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: "16px",
                  letterSpacing: "1px",
                }}
              >
                info@wellztech.com
              </span>
            </li>
            <li className="flex items-start">
              <MapPinIcon className="w-5 h-5 text-white mt-1 mr-3" />
              <span
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: "16px",
                  whiteSpace: "pre-line",
                  letterSpacing: "1px",
                }}
              >
                ODTÜ Teknokent, Silikon Blok{"\n"}Ankara, Türkiye
              </span>
            </li>
          </ul>
          <div
            className="absolute -bottom-20 -right-20"
            style={{
              width: "300px",
              height: "300px",
              backgroundColor: "var(--main-color-bold)",
              borderRadius: "50%",
              opacity: 0.5,
              pointerEvents: "none",
            }}
          />
        </div>
        {/* Dark glassmorphism form card */}
        <div
          className="w-3/5 p-8 overflow-auto rounded-[12px]"
          style={{
            backgroundColor: "rgba(13,17,23,0.9)",
            border: "1px solid rgba(255,255,255,0.1)",
            backdropFilter: "blur(20px)",
            boxShadow: "0 0 0 1px rgba(48,166,156,0.08), 0 24px 48px rgba(0,0,0,0.5)",
            "--main-color": anatomyConstants.mainColor,
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <p style={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.1em", color: "#64748B", textTransform: "uppercase" }}>
              DEMO REQUEST FORM
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="grid grid-cols-2 gap-6">
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: 600, letterSpacing: "0.08em", color: "#64748B", textTransform: "uppercase", marginBottom: "8px" }}>
                  First Name *
                </label>
                <input
                  type="text"
                  value={firstName}
                  required
                  placeholder="Dr. First Name"
                  onChange={(e) => setFirstName(e.target.value)}
                  style={{
                    width: "100%", backgroundColor: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px",
                    padding: "10px 14px", color: "#E7EBEF", fontSize: "14px", outline: "none",
                  }}
                  onFocus={(e) => e.currentTarget.style.borderColor = "#30A69C"}
                  onBlur={(e) => e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)"}
                />
              </div>
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: 600, letterSpacing: "0.08em", color: "#64748B", textTransform: "uppercase", marginBottom: "8px" }}>
                  Last Name *
                </label>
                <input
                  type="text"
                  value={lastName}
                  required
                  placeholder="Last Name"
                  onChange={(e) => setLastName(e.target.value)}
                  style={{
                    width: "100%", backgroundColor: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px",
                    padding: "10px 14px", color: "#E7EBEF", fontSize: "14px", outline: "none",
                  }}
                  onFocus={(e) => e.currentTarget.style.borderColor = "#30A69C"}
                  onBlur={(e) => e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)"}
                />
              </div>
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: 600, letterSpacing: "0.08em", color: "#64748B", textTransform: "uppercase", marginBottom: "8px" }}>
                  Institution
                </label>
                <input
                  type="text"
                  placeholder="Hospital / Clinic name"
                  style={{
                    width: "100%", backgroundColor: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px",
                    padding: "10px 14px", color: "#E7EBEF", fontSize: "14px", outline: "none",
                  }}
                  onFocus={(e) => e.currentTarget.style.borderColor = "#30A69C"}
                  onBlur={(e) => e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)"}
                />
              </div>
              <div>
                <label style={{ display: "block", fontSize: "11px", fontWeight: 600, letterSpacing: "0.08em", color: "#64748B", textTransform: "uppercase", marginBottom: "8px" }}>
                  Email *
                </label>
                <input
                  type="email"
                  value={email}
                  required
                  placeholder="example@hospital.com"
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    width: "100%", backgroundColor: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px",
                    padding: "10px 14px", color: "#E7EBEF", fontSize: "14px", outline: "none",
                  }}
                  onFocus={(e) => e.currentTarget.style.borderColor = "#30A69C"}
                  onBlur={(e) => e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)"}
                />
              </div>
            </div>
            <div>
              <label style={{ display: "block", fontSize: "11px", fontWeight: 600, letterSpacing: "0.08em", color: "#64748B", textTransform: "uppercase", marginBottom: "10px" }}>
                Select Subject
              </label>
              <div className="flex items-center space-x-6">
                {["Customer Support", "Sales", "Feedback"].map((opt) => (
                  <label key={opt} className="inline-flex items-center cursor-pointer" style={{ color: subject === opt ? "#30A69C" : "#64748B", fontSize: "14px" }}>
                    <input
                      type="radio"
                      name="subject"
                      value={opt}
                      checked={subject === opt}
                      onChange={() => setSubject(opt)}
                      style={{ accentColor: "#30A69C", marginRight: "6px" }}
                    />
                    {opt}
                  </label>
                ))}
              </div>
            </div>
            <div>
              <label style={{ display: "block", fontSize: "11px", fontWeight: 600, letterSpacing: "0.08em", color: "#64748B", textTransform: "uppercase", marginBottom: "8px" }}>
                Message (optional)
              </label>
              <textarea
                rows="4"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Specific questions or features you're interested in..."
                style={{
                  width: "100%", backgroundColor: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px",
                  padding: "10px 14px", color: "#E7EBEF", fontSize: "14px", outline: "none",
                  resize: "none",
                }}
                onFocus={(e) => e.currentTarget.style.borderColor = "#30A69C"}
                onBlur={(e) => e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)"}
              />
            </div>
            <div className="pt-2">
              <button
                type="submit"
                style={{
                  width: "100%", background: "linear-gradient(160deg, #35b5aa 0%, #249990 100%)",
                  color: "#fff", border: "none", borderRadius: "8px", padding: "13px",
                  fontWeight: 600, fontSize: "15px", cursor: "pointer",
                  boxShadow: "0 4px 14px rgba(48,164,151,0.35)", transition: "background 0.2s",
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = "linear-gradient(160deg, #249990 0%, #1a7068 100%)"}
                onMouseLeave={(e) => e.currentTarget.style.background = "linear-gradient(160deg, #35b5aa 0%, #249990 100%)"}
              >
                Send Message
              </button>
              <p style={{ textAlign: "center", fontSize: "12px", color: "#475569", marginTop: "12px" }}>
                Response time: 1–2 business days
              </p>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
